<template>
    <aside class="aside" v-if="$store.state.openLeftSide">
        <button type="button" class="nav_menu_btn waves-effect waves-light">
            <i class="mdi mdi-chevron-left minus"></i>
            <i class="mdi mdi-menu plus"></i>
        </button>

        <div class="logo"><a href=""><strong>Smart</strong> Bus Station</a></div>
        <lang-section></lang-section>
        <div class="nav_menu">
            <ul class="nav_menu_ls">
                <router-link to="/" tag="li">
                    <a href="" class="waves-effect waves-light">
                        <i class="mdi mdi-view-grid"></i>
                        <span class="txt">{{i18n("Main")}}</span>
                    </a>
                </router-link>
                <router-link to="/transportation-organization" tag="li" v-if="can('locations.index','stations.index','routes.index','schedules.index','tariffs.index','privileges.index','baggage.index','services.index','transporters.index','buses.index','bus.types.index')">
                    <a href="" class="waves-effect waves-light">
                        <i class="mdi mdi-map-marker"></i>
                        <span class="txt">{{i18n("Transportation organization")}}</span>
                    </a>
                </router-link>
                <router-link to="/dispatchment" tag="li" v-if="can('trips.index','reports.dispatcher_one')">
                    <a href="" class="waves-effect waves-light">
                        <i class="mdi mdi-bus"></i>
                        <span class="txt">{{i18n("Dispatching")}}</span>
                    </a>
                </router-link>
                <router-link to="/sales" tag="li" v-if="can('ticket.*')">
                    <a href="" class="waves-effect waves-light">
                        <i class="mdi mdi-cart"></i>
                        <span class="txt">{{i18n("Sales")}}</span>
                    </a>
                </router-link>
                <router-link to="/administration" tag="li" v-if="can('roles.*','users.*','cashiers.*','settings.*','return.services.*', 'reports.*')">
                    <a href="" class="waves-effect waves-light">
                        <i class="mdi mdi-settings"></i>
                        <span class="txt">{{i18n("Administration")}}</span>
                    </a>
                </router-link>
                <router-link to="/dashboard" tag="li" v-if="can('dashboard.*')">
                    <a href="" class="waves-effect waves-light">
                        <i class="mdi mdi-chart-bar"></i>
                        <span class="txt">{{i18n("Dashboard")}}</span>
                    </a>
                </router-link>
                <router-link to="/baggage-shipping/create" tag="li" v-if="can('baggage-shipping.create')">
                    <a href="" class="waves-effect waves-light">
                        <i class="mdi mdi-bag-checked"></i>
                        <span class="txt">{{i18n("Attach baggage")}}</span>
                    </a>
                </router-link>
                <li>
                    <a href="#" @click.prevent="logout" class="waves-effect waves-light">
                        <i class="mdi mdi-logout"></i>
                        <span class="txt">{{i18n("Logout")}}</span>
                    </a>
                </li>
            </ul>
        </div>
    </aside>
</template>

<script>
    import langSection from "./../../components/LangSection"
    export default {
        name: "Navigation",
        components: {
            langSection
        },
        props: {},
        methods: {}
    }
</script>

<style scoped>
</style>
